import { Video, Armchair } from "lucide-react";
import { Reveal, ChapterTag } from "./Reveal";

const POINTS = [
    { icon: Video, title: "Per Video", testid: "format-video-call", text: "Die Beratung findet online per Video statt." },
    { icon: Armchair, title: "Von deinem Ort", testid: "format-vor-ort", text: "Von einem ruhigen Ort aus, an dem du dich wohlfühlst und ungestört sprechen kannst." },
];

export const OnlineBeratung = () => (
    <section id="online" data-testid="online-beratung-section" className="py-24 sm:py-32 lg:py-40 bg-[#E6E1D5]">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
            <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
                <div className="lg:col-span-5">
                    <Reveal>
                        <ChapterTag number="04" label="Online-Beratung" />
                        <h2 className="font-serif font-light text-3xl sm:text-5xl tracking-tight text-[#2B2825]">
                            Beratung, wo du dich wohlfühlst.
                        </h2>
                        <p className="mt-7 font-sans text-base sm:text-lg font-light leading-relaxed text-[#59534C]">
                            Die Beratung findet online statt, von einem ruhigen Ort aus, an dem du dich wohlfühlst.
                        </p>
                        <p className="mt-4 font-sans text-base sm:text-lg font-light leading-relaxed text-[#59534C]">
                            Alles, was du dazu brauchst, ist eine stabile Internetverbindung und ein Ort, an dem du möglichst
                            ungestört sprechen kannst.
                        </p>
                    </Reveal>
                </div>

                <div className="lg:col-span-7 flex flex-col justify-center">
                    <div className="space-y-px bg-[#CFC7B8] border border-[#CFC7B8]">
                        {POINTS.map((p, i) => (
                            <Reveal key={p.title} delay={i * 0.1}>
                                <div
                                    data-testid={p.testid}
                                    className="bg-[#EFECE4] p-7 sm:p-8 flex items-start gap-6 hover:bg-[#FAF8F5] transition-colors duration-500"
                                >
                                    <p.icon size={22} strokeWidth={1.4} className="text-[#5E6B5A] shrink-0 mt-1" />
                                    <div>
                                        <h3 className="font-serif font-medium text-xl sm:text-2xl text-[#2B2825] mb-1.5">{p.title}</h3>
                                        <p className="font-sans text-sm font-light leading-relaxed text-[#59534C]">{p.text}</p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
);
